/**
 * @typedef {'link'|'qrcode'} FooterSocialActionType
 */

/**
 * @typedef {Object} FooterSocialItem
 * @property {string} key
 * @property {string} label
 * @property {string} icon
 * @property {string} iconHover
 * @property {FooterSocialActionType} action
 * @property {string} [href] - 外链地址（action=link）
 * @property {string} [qrImage] - 二维码图片（action=qrcode）
 * @property {string} [qrText] - 二维码说明文案
 */

/** @type {FooterSocialItem[]} */
export const FOOTER_SOCIAL_ITEMS = [
  {
    key: 'douyin',
    label: '抖音',
    icon: '/images/footer/douyin.svg',
    iconHover: '/images/footer/douyin-hover.svg',
    action: 'link',
    href: 'https://v.douyin.com/xTcooodTCRw/',
  },
  {
    key: 'bilibili',
    label: 'B站',
    icon: '/images/footer/bilibili.svg',
    iconHover: '/images/footer/bilibili-hover.svg',
    action: 'link',
    href: 'https://space.bilibili.com/3493118806591881?spm_id_from=333.1007.0.0',
  },
  {
    key: 'xiaohongshu',
    label: '小红书',
    icon: '/images/footer/xiaohongshu.svg',
    iconHover: '/images/footer/xiaohongshu-hover.svg',
    action: 'link',
    href: 'https://www.xiaohongshu.com/user/profile/608703ae000000000100b4cb',
  },
]
